import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DynamicFormService, FormFieldConfig } from '../../services/dynamic-form-service.service';

@Component({
  selector: 'ebw-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss']
})
export class DynamicFormComponent implements OnInit {
  @Input() formId: string;
  @Output() formSubmit = new EventEmitter<any>();

  form: FormGroup;
  fieldConfigs: FormFieldConfig[];
  attributeConfigs: FormFieldConfig[];

  constructor(private _fb: FormBuilder, private _dynamicFormService: DynamicFormService) {}

  ngOnInit(): void {
    if (this.formId) {
      this._dynamicFormService.getFormConfig(this.formId).subscribe((config) => {
        this.fieldConfigs = config.fields;
        this.attributeConfigs = config.attributes;
        this.form = this._fb.group(this.createFormGroupConfig(this.fieldConfigs.concat(this.attributeConfigs || [])));
      });
    } else {
      console.error('formId is not defined');
    }
  }

  createFormGroupConfig(fields: FormFieldConfig[]): { [key: string]: any } {
    const group: { [key: string]: any } = {};
    fields.forEach((field) => {
      const validators = field.required ? [Validators.required] : [];
      group[field.external_name] = new FormControl({ value: field.default || '', disabled: !field.editable }, validators);
    });
    return group;
  }

  onSubmit() {
    console.log('this.form.value', this.form.value);
    console.log('this.form.getRawValue()', this.form.getRawValue());
  }

  getFormState(): { isValid: boolean; values: any } {
    return {
      isValid: this.form.valid,
      values: this.form.getRawValue()
    };
  }

  formatLabel(name: string): string {
    return name.replace(/_/g, ' ').replace(/^./, (c) => c.toUpperCase());
  }

  resetForm(): void {
    this.form.clearValidators();
    this.form.reset();
  }

  submit() {
    if (this.form.valid) {
      this.formSubmit.emit(this.form.value);
    }
  }
}
